import { useLayoutEffect } from 'react'

// Uma única trava para modais e painéis, inclusive quando há camadas aninhadas.
let locks = 0
let saved: { x: number; y: number; css: string; rootCss: string; hadClass: boolean } | null = null

export function useOverlayScrollLock(open: boolean) {
  useLayoutEffect(() => {
    if (!open) return
    locks++
    if (!saved) {
      saved = { x: window.scrollX, y: window.scrollY, css: document.body.style.cssText, rootCss: document.documentElement.style.cssText, hadClass: document.body.classList.contains('modal-open') }
      document.body.classList.add('modal-open')
      Object.assign(document.documentElement.style, { overflow: 'hidden', overscrollBehavior: 'none' })
      Object.assign(document.body.style, {
        position: 'fixed', top: `-${saved.y}px`, left: `-${saved.x}px`,
        width: '100%', overflow: 'hidden', overscrollBehavior: 'none',
      })
    }
    return () => {
      locks--
      // Trocar um painel por outro no mesmo render mantém a posição da página.
      queueMicrotask(() => {
        if (locks || !saved) return
        const previous = saved
        saved = null
        document.body.style.cssText = previous.css
        document.documentElement.style.cssText = previous.rootCss
        if (!previous.hadClass) document.body.classList.remove('modal-open')
        window.scrollTo({ left: previous.x, top: previous.y, behavior: 'instant' })
      })
    }
  }, [open])
}
